/**
 * SalesMailer
 * SalesMailer
 *
 * OpenAPI spec version: n/a
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/';

import { AddContact } from '../model/addContact';
import { ContactDetails } from '../model/contactDetails';
import { ContactList } from '../model/contactList';
import { EditContact } from '../model/editContact';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContactsService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Dodawanie kontaktu przez Handlowca
     *  - __InputModelName__: AddContact - __InputParser__: constructor - __OperationName__: Handler - __OperationId__: AddContactHandler - __Name__:  - __Path__: /contacts - __Method__: POST - __Description__:  - __Summary__: Dodawanie kontaktu przez Handlowca - __RouteName__: POSTContactDetailsHandler - __Hash__: c2e4768df30961bd9150bc8b8ea34149 - __Input__: SalesMailer\\Domain\\Contact - __Output__: SalesMailer\\Domain\\Contact - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: ContactDetails - __OutputType__:  - __OutputFileType__:  
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addContactHandler(content?: AddContact, observe?: 'body', reportProgress?: boolean): Observable<ContactDetails>;
    public addContactHandler(content?: AddContact, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDetails>>;
    public addContactHandler(content?: AddContact, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDetails>>;
    public addContactHandler(content?: AddContact, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ContactDetails>(`${this.basePath}/api/contacts`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Szczegóły pojedynczego wpisu w książce adresowej
     *  - __Path__: /contacts/{id} - __OperationName__: Query - __OutputModelName__: ContactDetails - __Entity__: SalesMailer\\Domain\\Contact - __Type__: doctrine - __OperationId__: ContactDetailsQuery - __Name__:  - __Method__: GET - __Description__:  - __Summary__: Szczegóły pojedynczego wpisu w książce adresowej - __RouteName__: GETContactDetailsQuery - __Hash__: 2e1461e0632d4e3a2f2cf44deda59ffb - __Input__:  - __Output__: SalesMailer\\Domain\\Contact - __InputGroups__:  - __OutputGroups__: details - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contactDetailsQuery(id: string, observe?: 'body', reportProgress?: boolean): Observable<ContactDetails>;
    public contactDetailsQuery(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDetails>>;
    public contactDetailsQuery(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDetails>>;
    public contactDetailsQuery(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling contactDetailsQuery.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ContactDetails>(`${this.basePath}/api/contacts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista kontaktów wybranego handlowca
     *  - __Type__: doctrine - __PageSize__: 25 - __Entity__: SalesMailer\\Domain\\Contact - __OperationId__: ContactListQuery - __OperationName__: ListQuery - __OutputModelName__: ContactListItem - __ListModelName__: ContactList - __DefaultSortOrder__: lastName - __Name__:  - __Path__: /contacts - __Method__: GET - __Description__:  - __Summary__: Lista kontaktów wybranego handlowca - __RouteName__: GETContactListItemListQuery - __Hash__: 323b87ed9a4382edf74ad9ec6fe24435 - __Input__:  - __Output__: SalesMailer\\Domain\\Contact - __InputGroups__:  - __OutputGroups__: list - __InputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param sortOrder Pole według którego nastąpi sortowanie
     * @param sortDirection Kierunek sortowania
     * @param search  (text, like)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public contactListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', search?: string, observe?: 'body', reportProgress?: boolean): Observable<ContactList>;
    public contactListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactList>>;
    public contactListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactList>>;
    public contactListQuery(sortOrder?: string, sortDirection?: 'ASC' | 'DESC', search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }
        if (sortDirection !== undefined && sortDirection !== null) {
            queryParameters = queryParameters.set('sortDirection', <any>sortDirection);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ContactList>(`${this.basePath}/api/contacts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Usuwanie kontaktu przez Handlowca
     *  - __InputModelName__: DeleteContact - __Path__: /contacts/{id} - __IsDeletableMethodName__: isDeletable - __TarEntity__:  - __EntityId__:  - __OperationName__: Handler - __OperationId__: DeleteContactHandler - __Name__:  - __Method__: DELETE - __Description__:  - __Summary__: Usuwanie kontaktu przez Handlowca - __RouteName__: DELETEHandler - __Hash__: 2ce738095a7951fd70fe9e94b2d81c72 - __Input__: SalesMailer\\Domain\\Contact - __Output__:  - __InputGroups__:  - __OutputGroups__:  - __OutputModelName__:  - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteContactHandler(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteContactHandler(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteContactHandler(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteContactHandler(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteContactHandler.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/contacts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edycja kontaktu przez Handlowca
     *  - __InputParser__: method - __UpdateMethodName__: update - __Path__: /contacts/{id} - __InputModelName__: EditContact - __OperationName__: Handler - __OperationId__: EditContactHandler - __Name__:  - __Method__: PUT - __Description__:  - __Summary__: Edycja kontaktu przez Handlowca - __RouteName__: PUTContactDetailsHandler - __Hash__: 82e8e0e2aae1194ac01b787b5e6613af - __Input__: SalesMailer\\Domain\\Contact - __Output__: SalesMailer\\Domain\\Contact - __InputGroups__:  - __OutputGroups__: details - __OutputModelName__: ContactDetails - __OutputType__:  - __OutputFileType__:  
     * @param id ID
     * @param content 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editContactHandler(id: string, content?: EditContact, observe?: 'body', reportProgress?: boolean): Observable<ContactDetails>;
    public editContactHandler(id: string, content?: EditContact, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDetails>>;
    public editContactHandler(id: string, content?: EditContact, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDetails>>;
    public editContactHandler(id: string, content?: EditContact, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling editContactHandler.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ContactDetails>(`${this.basePath}/api/contacts/${encodeURIComponent(String(id))}`,
            content,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
